import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseForm } from 'src/app/view/base-form';
import { ProductosApiService } from 'src/app/service/api/productos-api';
import { DashboardService } from 'src/app/service/events/dashboard.service';
import { VentasApiService } from 'src/app/service/api/ventas-api.service';
import { ProductosFertilizantesFormDefinition } from './form-control/form-definition';
import {
    ReactiveFormChangedField,
    ReactiveFormStableValueChange,
    ReactiveFormValue,
} from '@fitogest/reactive-form-builder/interfaces';

import type { ProductosModel } from 'src/app/models/productos/productos.model';

@Component({
    selector: 'app-producto-fertilizante-form',
    standalone: false,
    templateUrl: './producto-fertilizante-form.component.html',
    styleUrls: ['./producto-fertilizante-form.component.scss'],
})
export class ProductoFertilizanteFormComponent extends BaseForm<ProductosModel> implements OnInit {
    public override model: ProductosModel = { nombre: '', materia_activa: '', tipo: 'fertilizante' };

    public form!: ProductosFertilizantesFormDefinition;
    public reactiveFormRecordId = '';

    public constructor(
        public override route: ActivatedRoute,
        public dashboardEvents: DashboardService,
        public productApi: ProductosApiService,
        private readonly ventasApi: VentasApiService,
        public override router: Router,
    ) {
        super(
            route,
            router,
            dashboardEvents,
            productApi.productos.PUT,
            productApi.productos.POST,
            'productos-fertilizantes',
            'Actualizar Fertilizante',
            'Crear Fertilizante',
        );
    }// constructor();

    public ngOnInit(): void {
        this.model = this.initializeHostModel(this.buildInitialModel(this.getModel()));
        this.reactiveFormRecordId = this.resolveReactiveFormRecordId(this.model);
        this.form = new ProductosFertilizantesFormDefinition(
            this.getType(),
            this.model,
            null,
            { empresa: this.ventasApi.compradoresGET },
        );

        this.softInit(this.getType());
    }// ngOnInit();


    public stableValueChanges(event: ReactiveFormStableValueChange<ProductosModel>): void {
        const modelChanges = this.captureStableValueChange(event.value as ProductosModel);

        this.updateFormModel(modelChanges as ReactiveFormValue<ProductosModel>, event.changedField);
    }// stableValueChanges();


    public override goBack(): void {
        this.router.navigate(['dashboard', this.pathToGoBack]);
    }// goBack();

    private updateFormModel(
        formModel: ReactiveFormValue<ProductosModel>,
        lastChangedFieldName: ReactiveFormChangedField<ProductosModel>,
    ): void {
        this.form.updateModel(formModel, lastChangedFieldName);
        this.model = this.form.model as ProductosModel;
    }// updateFormModel();

    private buildInitialModel(routeModel: ProductosModel): ProductosModel {
        return {
            ...routeModel,
            tipo: 'fertilizante',
        } as ProductosModel;
    }// buildInitialModel();

}// class;
